import type { ReactNode } from "react";

type Props = {
  title: ReactNode;
  testId: string;
  children: ReactNode;
};

/**
 * Shared shell for the cards inside the EV info section — range and battery (MBJ-300),
 * charging (MBJ-301) and guides (MBJ-302) all sit on the same white card with the same heading.
 */
export const EvInfoCard = ({ title, testId, children }: Props) => {
  return (
    <section data-testid={testId} className="s-bg rounded-8 p-16">
      <h2 className="t3 mt-0 mb-16">{title}</h2>
      {children}
    </section>
  );
};
